import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../utils";
import TeamCreateModal from './CreateModal';
import TeamEditModal from './EditModal';
import { Button } from "react-bootstrap";
import TeamFilter from './TeamFilters';
import TeamViewSide from './TeamSideView';
const TeamsPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isFilter, setIsFilter] = useState(false)
    const [isView, setIsView] = useState(false)
    const columns = [
        {
            name: 'League',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Team',
            selector: row => row.price,
            sortable: true,
        },
        {
            name: '# of Seats',
            selector: row => row.mobile,
            sortable: true,
        },
        {
            name: 'Total Cost',
            selector: row => row.mobile,
            sortable: true,
        },
        {
            name: 'PSL Total',
            selector: row => row.mobile,
            sortable: true,
        },
        {
            name: 'Total Amounts',
            selector: row => row.mobile,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row, i) => {
                return (
                    <>
                        <div className="hstack gap-1 fs-1">
                            <button
                                aria-label="anchor"
                                onClick={() => setIsView(true)}
                                className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-eye-fill" />
                            </button>
                            <button
                                aria-label="anchor"
                                onClick={() => setIsEdit(true)}
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-edit-line" />
                            </button>
                            <a
                                aria-label="anchor"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-delete-bin-7-line" />
                            </a>
                        </div>
                    </>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const data = [
        {
            name: 'League 1',
            price: 'Team A',
            mobile: 100,
            totalCost: 500,
            pslTotal: 200,
            totalAmounts: 800,
            addedBy: 'User 1',
            updatedBy: 'User 2',
            createdAt: '2024-03-24T12:00:00Z',
            updatedAt: '2024-03-24T12:00:00Z'
        },
        {
            name: 'League 2',
            price: 'Team B',
            mobile: 150,
            totalCost: 750,
            pslTotal: 300,
            totalAmounts: 1050,
            addedBy: 'User 3',
            updatedBy: 'User 4',
            createdAt: '2024-03-23T12:00:00Z',
            updatedAt: '2024-03-23T12:00:00Z'
        },
        {
            name: 'League 3',
            price: 'Team C',
            mobile: 120,
            totalCost: 600,
            pslTotal: 240,
            totalAmounts: 840,
            addedBy: 'User 5',
            updatedBy: 'User 6',
            createdAt: '2024-03-22T12:00:00Z',
            updatedAt: '2024-03-22T12:00:00Z'
        },
        {
            name: 'League 4',
            price: 'Team D',
            mobile: 200,
            totalCost: 1000,
            pslTotal: 400,
            totalAmounts: 1400,
            addedBy: 'User 7',
            updatedBy: 'User 8',
            createdAt: '2024-03-21T12:00:00Z',
            updatedAt: '2024-03-21T12:00:00Z'
        },
        {
            name: 'League 5',
            price: 'Team E',
            mobile: 180,
            totalCost: 900,
            pslTotal: 360,
            totalAmounts: 1260,
            addedBy: 'User 9',
            updatedBy: 'User 10',
            createdAt: '2024-03-20T12:00:00Z',
            updatedAt: '2024-03-20T12:00:00Z'
        },
        {
            name: 'League 6',
            price: 'Team F',
            mobile: 90,
            totalCost: 450,
            pslTotal: 180,
            totalAmounts: 630,
            addedBy: 'User 11',
            updatedBy: 'User 12',
            createdAt: '2024-03-19T12:00:00Z',
            updatedAt: '2024-03-19T12:00:00Z'
        },
        {
            name: 'League 7',
            price: 'Team G',
            mobile: 160,
            totalCost: 800,
            pslTotal: 320,
            totalAmounts: 1120,
            addedBy: 'User 13',
            updatedBy: 'User 14',
            createdAt: '2024-03-18T12:00:00Z',
            updatedAt: '2024-03-18T12:00:00Z'
        },
        {
            name: 'League 8',
            price: 'Team H',
            mobile: 220,
            totalCost: 1100,
            pslTotal: 440,
            totalAmounts: 1540,
            addedBy: 'User 15',
            updatedBy: 'User 16',
            createdAt: '2024-03-17T12:00:00Z',
            updatedAt: '2024-03-17T12:00:00Z'
        },
        {
            name: 'League 9',
            price: 'Team I',
            mobile: 140,
            totalCost: 700,
            pslTotal: 280,
            totalAmounts: 980,
            addedBy: 'User 17',
            updatedBy: 'User 18',
            createdAt: '2024-03-16T12:00:00Z',
            updatedAt: '2024-03-16T12:00:00Z'
        },
        {
            name: 'League 10',
            price: 'Team J',
            mobile: 250,
            totalCost: 1250,
            pslTotal: 500,
            totalAmounts: 1750,
            addedBy: 'User 19',
            updatedBy: 'User 20',
            createdAt: '2024-03-15T12:00:00Z',
            updatedAt: '2024-03-15T12:00:00Z'
        }
    ];

    return (
        <>
            <PageHeader name="Teams" />


            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6 ">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start">
                                    <div className="flex-grow-1">
                                        <p className="mb-0">Total Cost</p>
                                        <span className="fs-5">12,000</span>
                                    </div>
                                    <div className="min-w-fit-content ms-3">
                                        <span className="avatar avatar-md br-5 bg-primary-transparent text-primary">
                                            <i className="fe  fs-18" >$</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 ">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start">
                                    <div className="flex-grow-1">
                                        <p className="mb-0"># of Seats</p>
                                        <span className="fs-5">120</span>
                                    </div>
                                    <div className="min-w-fit-content ms-3">
                                        <span className="avatar avatar-md br-5 bg-secondary-transparent text-secondary">
                                            <i className="fe fe-package fs-18" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start">
                                    <div className="flex-grow-1">
                                        <p className="mb-0"># of Accounts</p>
                                        <span className="fs-5">77</span>
                                    </div>
                                    <div className="min-w-fit-content ms-3">
                                        <span className="avatar avatar-md br-5 bg-warning-transparent text-warning">
                                            <i className="fe fe-user fs-18" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 ">
                                    <div className="col-auto p-0 d-flex">
                                        <Button className="btn btn-primary" onClick={() => setIsShow(true)}>
                                            Create Team
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => setIsFilter(true)}
                                        >
                                            <i className="ri-filter-2-fill" />
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0 ms-auto">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body">

                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <TeamCreateModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
            <TeamEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            />
            <TeamFilter
                show={isFilter}
                close={() => setIsFilter(false)}
            />
            <TeamViewSide
                show={isView}
                close={() => setIsView(false)}
            />
        </>
    );
};

export default TeamsPage;